import { CSSObject } from '@chakra-ui/react';

export const Wrapper: CSSObject = {
  h: ['55px', null, '108px'],
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const TextItem = {
  color: 'white',
  textAlign: 'center',
  fontSize: 'sm',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'normal',
  pos: ['relative', null, 'absolute'],
  top: ['unset', null, '600px'],
  px: '5',
};

export const LinkItem = {
  color: 'beta.500',
  fontWeight: 'bold',
};
